












































import ProjectList from '../components/ProjectList.vue';
import Vue from 'vue';
import { ProjectId, ProjectDef } from '@/types/Project';

enum State {
    Loading = 'loading',
    Loaded = 'loaded',
}

// noinspection JSUnusedGlobalSymbols
export default Vue.extend({
    components: { ProjectList },

    data() : {
        state: State,
        username?: string,
        projectList: ProjectDef[],
    } {
        return {
            state: State.Loading,
            username: this.$store.state.user.loggedIn ? this.$store.state.user.user!.username : undefined,
            projectList: [],
        };
    },

    methods: {
        async updateProjectList() {
            this.state = State.Loading;
            if (this.$store.state.user.loggedIn) {
                await this.$store.dispatch('projectList/updateList');
                this.projectList = this.$store.state.projectList.list;
                this.username = this.$store.state.user.user!.username;
                this.state = State.Loaded;
                if (this.$store.state.projectList.list.length === 0)
                    await this.$router.push('/new-project');
            }
        },
    },

    computed: {
        userLoggedIn() : boolean {
            return this.$store.state.user.loggedIn;
        },
    },

    watch: {
        userLoggedIn() {
            this.updateProjectList();
        },
    },

    async mounted() {
        await this.updateProjectList();
    },
});
